export default __webpack_public_path__ + "static/media/ClearDay.224c29f9.mp4";